import {
  parseBoolTrue,
  parseFloat,
  parseNumber,
  transformModel,
} from '~/src/dash/api/resource-transforms';

interface IChannelParams {
  [key: string]: string;
}

export const SITE_PARAMS_REQUIRED_TYPE: IChannelParams = {
  app_bundle: '[APP_BUNDLE]',
  site_page: '[SITE_PAGE]',
  site_id: '[SITE_ID]',
  format: '[FORMAT]',
};

export const SITE_PARAMS_NOT_EDITABLE_TYPE: IChannelParams = {
  site_id: '[SITE_ID]',
  min_ad_duration: '',
  max_ad_duration: '',
};

// Used to determine which parameters are required in building a cache keye
export interface IBidSaverConfig {
  DeviceId: true;
  SiteId: true;
  IP: true;
  ContentRating: true;
  ContentGenre: true;
  TTL: number;
  ContentId?: boolean;
  AppBundle?: boolean;
  StoreBelowFloorBids: boolean;
  MaxUnderFloorType?: number;
  MaxUnderFloorValue?: number;
  MinBidFloor?: number;
}

export const transformBidSaverConfig = transformModel<IBidSaverConfig>({
  DeviceId: parseBoolTrue(['DeviceId']),
  SiteId: parseBoolTrue(['SiteId']),
  IP: parseBoolTrue(['IP']),
  TTL: parseNumber(['TTL']),
  ContentRating: parseBoolTrue(['ContentRating']),
  ContentGenre: parseBoolTrue(['ContentGenre']),
  ContentId: parseBoolTrue(['ContentId']),
  AppBundle: parseBoolTrue(['AppBundle']),
  StoreBelowFloorBids: parseBoolTrue(['StoreBelowFloorBids']),
  MaxUnderFloorType: parseNumber(['MaxUnderFloorType']),
  MaxUnderFloorValue: parseFloat(['MaxUnderFloorValue']),
  MinBidFloor: parseFloat(['MinBidFloor']),
});

export const DEFAULT_BID_SAVER_CONFIG: IBidSaverConfig = {
  DeviceId: true, // cannot be changed
  SiteId: true, // cannot be changed
  IP: true, // cannot be changed
  ContentGenre: true, // cannot be changed
  ContentRating: true, // cannot be changed
  ContentId: false,
  AppBundle: false,
  TTL: 60,
  StoreBelowFloorBids: false,
  MaxUnderFloorType: 0,
  MaxUnderFloorValue: 0,
  MinBidFloor: 0,
};
